// extracted by mini-css-extract-plugin
export var closeButton = "_nz-1";
export var closeX = "_nz-3";
export var container = "_nz-0";
export var image = "_nz-2";